import React, { Component } from 'react'
import './Shipulator.css'

export default class Shipulator extends Component {
    render() {
        return (
            <div className="ShipulatorApp">
                <div className="PageContent">
                    <div className="ShipTitle">Shipulator</div>
                    <div className="ShipDesc">
                        Shipulator is an abstract manager game with inspiration taken from clicker games. I'm still working on it.
                    </div>
                    <div className="ShipDownloadButton">SOON</div>
                </div>
            </div>
        )
    }
}
